<template>
  <Hero v-editable="blok" :title-length="blok.title?.length" :longest-word="longestWord">
    <template #background>
      <NuxtImg v-if="blok.image?.filename" :src="blok.image.filename" width="1600" quality="60" format="webp" alt="" />
    </template>
    <h1>{{ blok.title }}</h1>
    <p>
      <time v-if="publishedAt" :datetime="publishedAt">{{ publishedOn }}. </time>{{ blok.teaser }}
    </p>
  </Hero>
  <Container>
    <div :class="$style['article']">
      <Button :to="{path: '/over-ons/nieuws'}" icon="ArrowLeft" icon-pos="left" variant="outline" class="h-margin-bottom-xxl">
        Al het nieuws
      </Button>
      <LazySbText v-editable="blok" :blok="blok" />
    </div>
  </Container>
</template>
<script setup>
import { convert } from 'html-to-text'
const route = useRoute()
const url = useRequestURL()
const { formatNewsItem, formatNewsItemBreadcrumbs } = useHrMeta()
const props = defineProps({ blok: Object })
const story = inject('story', computed(() => undefined))
formatNewsItem({ title: props.blok.title, teaser: props.blok.teaser, description: convert(renderRichText(props.blok.text)), image: props.blok.image, url: url.href, publishedAt: story.value?.first_published_at ?? story.value?.published_at, updatedAt: story.value?.published_at })
formatNewsItemBreadcrumbs({ name: props.blok.title, url: route.fullPath })

const longestWord = computed(() => Math.max(0, ...String(props.blok.title ?? '').split(/\s+/).map(word => word.length)))
const publishedAt = computed(() => story.value?.first_published_at || story.value?.published_at)
const publishedOn = computed(() => {
  const date = publishedAt.value
  return date ? new Date(date).toLocaleDateString('nl-NL', { year: 'numeric', month: 'long', day: 'numeric' }) : ''
})
</script>
<style module>
/* The article in the same centred reading column as the other pages */
.article {
  max-width: var(--stage-measure);
  margin-inline: auto;
}
</style>
